<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<vxe-toolbar>
					<template #buttons>
						<vxe-button status="success" @click="exportDataEvent">导出</vxe-button>
					</template>
				</vxe-toolbar>
				<vxe-table ref="performanceTable" height="600" align="center" size="mini" :data="tabledata">
					<vxe-colgroup field="b" :title="tabletitle">
						<vxe-column type="seq" width="60"></vxe-column>
						<vxe-column field="departmentid" title="组别"></vxe-column>
						<vxe-column field="psnNickName" title="昵称"></vxe-column>
						<vxe-column field="validReplyUv1d" title="接待"></vxe-column>
						<vxe-column field="cstUsrCnt1d" title="询单"></vxe-column>
						<vxe-column field="avgReplyDur1d" title="均响"></vxe-column>
						<vxe-column field="allCstSftRate" title="满意比"></vxe-column>
						<!-- <vxe-column field="ordUsrCntFinalNd" title="成交数"></vxe-column> -->
						<vxe-colgroup field="b" title="销售额">
							<vxe-column field="realPayAmt1dtarget" title="目标"></vxe-column>
							<vxe-column field="realPayAmt1d" sortable title="达成"></vxe-column>
							<vxe-column field="realPayAmt1dpercent" sortable title="达成率"></vxe-column>
						</vxe-colgroup>
						<vxe-colgroup field="b" title="转化">
							<vxe-column field="conversionratetarget" title="目标"></vxe-column>
							<vxe-column field="conversionrate" sortable title="达成"></vxe-column>
							<vxe-column field="conversionratepercent" sortable title="达成率"></vxe-column>
						</vxe-colgroup>
						<vxe-column field="customerprice" title="客单价"></vxe-column>
					</vxe-colgroup>
				</vxe-table>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			sourcedata: {
				default: () => {
					return []
				}
			},
			kpi: {
				default: () => {
					return []
				}
			},
			param: {
				default: () => {
					return []
				}
			},			
			
			
		},
		data() {
			return {
				modal_model: false,
				modal_title: '战绩报表',
				modal_width: 1200,
				modal_height: 800,
				tabledata: [],
				tabletitle:'战绩报表'
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_onshow() {
				this.init()
			},
			init() {
				//console.log(this.param)
				this.tabletitle = '战绩报表【'+this.$systemMethods.timestampToDate(this.param.date[0],true)+' - '+this.$systemMethods.timestampToDate(this.param.date[1],true)+'】'
				let staticdepartment = [4,13]
				let sourcedata = JSON.parse(JSON.stringify(this.sourcedata))
				sourcedata = sourcedata.filter((item)=>{
					return !staticdepartment.includes(item.departmentid)
				})
				sourcedata = this.$Lodash.sortBy(sourcedata, 'departmentid')
				let groupedData = this.$Lodash.groupBy(sourcedata, 'psnNickName')
				let tabledata = []
				console.log(groupedData)
				for (let i in groupedData) {
					let validReplyUv1d = 0
					let avgReplyDur1d = 0
					let cstUsrCnt1d = 0
					let ordUsrCntFinalNd = 0
					let obj = {}
					obj.departmentid = this.$systemMethods.getdepartment(groupedData[i][0].departmentid)
					obj.psnNickName = i
					obj.validReplyUv1d = (this.$Lodash.sumBy(groupedData[i], item => parseFloat(item.validReplyUv1d)))
						.toFixed(2)
					obj.cstUsrCnt1d = (this.$Lodash.sumBy(groupedData[i], item => parseFloat(item.cstUsrCnt1d))).toFixed(2)
					obj.realPayAmt1d = (this.$Lodash.sumBy(groupedData[i], item => parseFloat(item.realPayAmt1d))).toFixed(
						2)
					groupedData[i].forEach((item) => {
						validReplyUv1d += item.validReplyUv1d ? parseFloat(item.validReplyUv1d) : 0
						avgReplyDur1d += item.avgReplyDur1d * item.validReplyUv1d
						cstUsrCnt1d += item.cstUsrCnt1d ? parseFloat(item.cstUsrCnt1d) : 0
						ordUsrCntFinalNd += item.ordUsrCntFinalNd ? parseFloat(item.ordUsrCntFinalNd) : 0
					})

					if (cstUsrCnt1d) {
						obj.conversionrate = (ordUsrCntFinalNd / cstUsrCnt1d * 100).toFixed(2)
					}
					if (validReplyUv1d) {
						obj.avgReplyDur1d = (avgReplyDur1d / validReplyUv1d).toFixed(2)
					}
					obj.allCstSftRate = (this.$Lodash.meanBy(groupedData[i], item => parseFloat(item.allCstSftRate)))
						.toFixed(2)
					obj.ordUsrCntFinalNd = parseInt(this.$Lodash.sumBy(groupedData[i], item => parseFloat(item
						.ordUsrCntFinalNd)))
					if (ordUsrCntFinalNd) {
						obj.customerprice = (obj.realPayAmt1d / obj.ordUsrCntFinalNd).toFixed(2)
					}

					tabledata.push(obj)
				}

				let kpigroupedData = this.$Lodash.groupBy(this.kpi, 'content')
				for (let i in kpigroupedData) {
					kpigroupedData[i] = this.$Lodash.groupBy(kpigroupedData[i], 'staffname')
				}
				tabledata.forEach((item) => {
					for (let i in kpigroupedData) {
						if (kpigroupedData[i][item.psnNickName]) {
							let target = 0
							if (i == '净销售额') {
								target = this.$Lodash.sumBy(kpigroupedData[i][item.psnNickName], item =>
									parseFloat(item.target))
								item.realPayAmt1dtarget = target
								item.realPayAmt1dpercent = (item.realPayAmt1d / target * 100).toFixed(2) +
									'%'
							}
							if (i == '转化率(%)') {
								target = this.$Lodash.sumBy(kpigroupedData[i][item.psnNickName], item =>
									parseFloat(item.target))
								item.conversionratetarget = target
								if(item.conversionrate && target){
									item.conversionratepercent = (item.conversionrate / target * 100).toFixed(2) +
										'%'
								}
							}
						}
					}
				})
				this.tabledata = tabledata
				console.log(tabledata)
			},
			exportDataEvent(){
				this.$refs.performanceTable.exportData({ type: 'xlsx' })
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>